import React from 'react';
import PropTypes from 'prop-types';

import S from 'app/features/landing/seriesCollection/components/SeriesCollection.styled';
import Image from 'app/components/Image';

const SeriesThumbnail = ({ image, name }) => (
  <S.SeriesCard>
    <S.Card.Thumbnail>
      <S.Card.Image as={Image} src={image} alt={name} />
    </S.Card.Thumbnail>
  </S.SeriesCard>
);

SeriesThumbnail.propTypes = {
  name: PropTypes.string.isRequired,
  image: PropTypes.string,
};

SeriesThumbnail.defaultProps = {
  image: '',
};

export default SeriesThumbnail;
